@if (type === 'adhoc') {
  <div style="margin: 5px; padding: 5px">
    <div style="width: 98%">
      <div id="video-header" style="width: 98%">
        <div style="width: 95%; background-color: #fff; display: inline-block; border: solid 1px #4b4a4a88">
          <input #adhocVideoInput [(ngModel)]="adhocVideoUrl" style="width: 90%; padding-left: 2px; border: solid 0px #fff" placeholder="URL" />
          <i class="fa fa-times" style="cursor: pointer; float: right; margin-right: 5px; margin-top: 4px" title="clear" (click)="clearUrlField()"></i>
        </div>
        <i class="fa fa-play" style="margin-left: 5px; margin-top: 5px; float: right; cursor: pointer" title="play" (click)="playAdHocVideo()"></i>
      </div>
    </div>
    @if (useImgForAdHoc) {
      <img #adhocImg id="video-img" style="width: 98%; margin-top: 5px; border: solid 1px #00000038" [src]="''" />
    }
    @if (!useImgForAdHoc) {
      <video #adhocVideo class="player" style="margin: auto; margin-top: 5px; border: solid 0px #fff;" width="100%" height="100%" controls autoplay></video>
    }
  </div>
}

@if (type !== 'adhoc' && !isHttp) {
  <div style="padding: 5px">
    <div id="loading" style="visibility: visible">Loading Video...</div>
    <video #mainVideo class="player" style="margin: auto; margin-top: 5px; border: solid 0px #fff; visibility: hidden"
    width="100%" height="100%" controls autoplay></video>
    <br>
      <span id="refreshSpan" (click)="refreshHLSPlayer()" style="visibility: hidden">
        <i class="fa fa-refresh" style="cursor: pointer" title="click to refresh if video stalled"></i>
      </span>
    </div>
  }

  @if (type !== 'adhoc' && isHttp) {
    <div style="padding: 5px">
      @if (useImgForHttp) {
        <img #httpImg style="width: 98%; margin-top: 5px; border: solid 0px #fff" [src]="cameraUrl" />
      }
      @if (!useImgForHttp) {
        <video #httpVideo class="player" style="margin: auto; margin-top: 5px; border: solid 1px #fff;"
        width="100%" height="100%" controls autoplay></video>
      }
    </div>
  }